//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import orderList from './list'
import historyBackJS from "../common/historyBack";
export default {
    components: {
        orderList
    },
    mixins: [historyBackJS],
    data() {
        return {
            activeIndex: 0,
            tabItem: [{
                title: '全部订单'
            },{
                title: '待付款'
            },{
                title: '待发货'
            },{
                title: '待收货'
            }]
        }
    },
    watch: {
        activeIndex(val) {
            this.$router.replace("/order?index="+val);
        }
    },
    methods: {
        goBack(replace = false) {
            if(replace) {
                this.$router.replace("/mine");
            } else {
                this.$router.push("/mine");
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
           this.activeIndex = parseInt(this.$route.query.index); 
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/order/index.vue